import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone-over2",
  "use": "icon-phone-over2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-phone-over2\"><path d=\"M933.4784 359.0656l-10.24-8.9088h-71.0144L788.48 184.32h-124.7232l-51.2-85.1968H416L365.2608 184.32h-128.512L170.5984 350.1568H102.4l-10.24 8.9088c-33.4336 29.3376-45.7728 69.9392-32.2048 105.8304a85.0432 85.0432 0 0 0 46.08 47.9232l-25.344 63.5392v350.1056h196.5056v-92.16h464.3328v94.976h196.7104v-352.6144l-23.4496-61.8496a85.1456 85.1456 0 0 0 50.8416-49.92c13.568-35.8912 1.2288-76.4928-32.1536-105.8304zM375.9616 397.4144l58.6752 40.96-3.8912 5.632h237.9264v71.68H292.9664z m278.6304 280.8832l-58.7264-40.96 3.9424-5.5808H361.8304v-71.68h375.7568z\" fill=\"#00A0FE\" p-id=\"1029\" /><path d=\"M116.48 926.72h160.7168v-92.16H80.64v92.16zM741.5296 834.5088h196.7616v94.6688h-196.7616z\" fill=\"#97D8FF\" p-id=\"1030\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone-over2.svg
// module id = vyAk
// module chunks = 42